import {
  Avatar,
  Box,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useClipboard,
} from "@chakra-ui/react";
import { ChatContent } from "@/types/writing";
import { useSelector, useDispatch } from "react-redux";
import { clearUser, selectAvatar, selectUser } from "@/reducer/userslice";
import { RiDeleteBin4Line, RiFileCopy2Line, RiMore2Line } from "@remixicon/react";
import { useState } from "react";

type Props = {
  sessionContent: ChatContent;
};

const HumanSessionItem2 = (props: Props) => {
  const { sessionContent } = props;
  const avatar = useSelector(selectAvatar);
  const { onCopy } = useClipboard(sessionContent.message);

  const handleCopy = () => {
    onCopy();
  };
  const handleDelete = () => {

  }

  return (
    <>
      <Flex justifyContent={"flex-end"} alignItems="flex-start" mb="10px">
        <Box>
          <Menu direction="rtl" placement="left" >
            <MenuButton
              as={IconButton}
              minW="18px"
              boxSize="18px"
              icon={<RiMore2Line size={"16px"} />}
              variant="unstyled"
              color={"#CBD1DF"}
              aria-label="操作"
              borderRadius={0}
              _hover={{
                color: "#000"
              }}
              _focusVisible={{
                boxshadow: "none"
              }}
            />

            <MenuList
              w="90px"
              minW={"90px"}
              bgColor="#fff"
              color={"#27314D"}
              borderColor={"#fff"}
              borderRadius={0}
              fontSize="14px"
              boxShadow={"md"}
              p="0"
            >
              <MenuItem icon={<RiFileCopy2Line size={"14px"} />} onClick={handleCopy}>
                复制
              </MenuItem>
              {/* <MenuItem icon={<RiDeleteBin4Line size={"14px"} />} onClick={handleDelete}>
                删除
              </MenuItem> */}
            </MenuList>
          </Menu>
        </Box>
        <Box maxW={"70%"}>
          <Box
            bgColor={"#496AE1"}
            p="10px"
            borderRadius={"5px"}
            boxSizing="border-box"
            color={"#FFFFFF"}
            fontSize="14px"
            mb={"20px"}
          >
            {sessionContent.message}
          </Box>
          {/* {sessionContent.files &&
            sessionContent.files.map((file) => {
              // 使用文件扩展名获取图标
              const suffix = file.name.split(".").pop();
              const iconSrc = suffix ? fileIcons[suffix] : "";
              const fileSize = Number(
                math.divide(math.bignumber(file.size), math.bignumber(1024))
              );

              return (
                <Flex w="300px" bg="#fff" p="14px" alignItems={"center"}>
                  {iconSrc && (
                    <Image mr="16px" boxSize={"34px"} src={iconSrc} />
                  )}
                  <Box flex={1}>
                    <Box
                      color={"#333333"}
                      fontSize="16px"
                      overflow={"hidden"}
                      textOverflow="ellipsis"
                      whiteSpace="nowrap"
                    >
                      {file.name}
                    </Box>
                    <HStack>
                      <Text color={"#8E94A9"} fontSize="12px">
                        {suffix}
                      </Text>
                      <Text color={"#8E94A9"} fontSize="12px">
                        {math.round(fileSize, 2)}K
                      </Text>
                    </HStack>
                  </Box>
                </Flex>
              );
            })} */}
        </Box>
        <Avatar
          ml="14px"
          w="40px"
          h="40px"
          name="ALDGPT"
          borderRadius={"2px"}
          src={avatar}
        />
      </Flex>
    </>
  );
};

export default HumanSessionItem2;
